import React from 'react';
import OeTip from './OeTip';

/**
 * Prüfmodal vor dem Speichern (Original `#overlay` HTML 806–815 und `save()`
 * 5160).
 *
 * Es zeigt jede Änderung als eigene Zeile, farbcodiert: blau geändert, grün
 * neu, rot entfällt. Gespeichert wird erst nach ausdrücklicher Bestätigung —
 * der Speichervorgang schreibt den kompletten Beleg nach weclapp zurück und
 * ist nicht mit einem Klick rückgängig zu machen.
 *
 * @param {boolean} show
 * @param {{t: string, txt: string}[]} changes
 * @param {{label: string, pct: number}[]} discountHints - erfüllte, noch nicht gesetzte Staffeln.
 * @param {?string} reworkText - Hinweis bei festgeschriebenem Beleg.
 * @param {boolean} busy
 * @param {() => void} onCancel
 * @param {() => void} onConfirm
 */
export default function ChangesReviewModal({show, changes, discountHints, reworkText, busy, onCancel, onConfirm}) {
    if (!show) {
        return null;
    }

    const hints = discountHints || [];

    return (
        <div className="overlay show" role="dialog" aria-modal="true" aria-labelledby="oe-review-title">
            <div className="modal">
                <h2 id="oe-review-title">Änderungen prüfen</h2>

                {reworkText ? <div className="hint">{reworkText}</div> : null}

                <div className="list">
                    {hints.length ? (
                        <div className="hint" style={{background: '#eff6ff', color: '#1e40af'}}>
                            💡 Der Auftrag erfüllt Rabattkriterien, die noch nicht angewendet sind:{' '}
                            {hints.map((h) => `${h.label} → ${h.pct} %`).join(', ')}
                            {' '}— über „% Staffelrabatte anwenden" setzen, wenn gewünscht.
                        </div>
                    ) : null}
                    {changes.map((c, i) => (
                        <div key={i} className={c.t}>{c.txt}</div>
                    ))}
                </div>

                <div className="btns">
                    <OeTip tip="Schließt die Prüfung. Die Änderungen bleiben in der Tabelle stehen und gehen nicht nach weclapp.">
                        <button type="button" disabled={busy} onClick={onCancel}>Abbrechen</button>
                    </OeTip>
                    <OeTip tip="Schreibt genau diese Liste nach weclapp. Der Fortschritt läuft unten links; bei festgeschriebenen Aufträgen dauert es ein bis zwei Minuten.">
                        <button type="button" className="primary" disabled={busy} onClick={onConfirm}>
                            Jetzt speichern
                        </button>
                    </OeTip>
                </div>
            </div>
        </div>
    );
}
